const ColdChains = () => {
  return (
    <div>
      <div className="flex flex-col justify-center items-center">
        <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]" />
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
          <div className="flex flex-col justify-center">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
              Cold Chain Management
            </h1>

            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              With fleets of temperature-controlled primary and secondary
              logistics vehicles, strategically located warehouses and
              distribution centres across the country and an advanced Fleet
              Integrated Management System (FIMS), TCS capabilities cover the
              full scope of temperature-sensitive logistics. We provide LTL,
              FTL, Door-to-Door, and Live Track and Trace services for
              industries including technology, pharmaceuticals, ambient, and
              perishables.
            </p>
            {/* <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
            From the origin to the destination, TCS capabilities cover the full scope of temperature-sensitive logistics 
            for businesses including technology, pharmaceuticals, ambient, chilled and frozen foods, with LTL, FTL, Door 
            to Door and Live Track & Trace services.
            </p> */}
          </div>
          <div className="flex-1 flex flex-col justify-center items-center sm:mt-[0rem] mt-[1rem]">
            <img
              src="/DomesticScrollingBanner/Inside-Cold-Chain-2.jpg"
              alt=""
              className="rounded-md max-w-[100%] "
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default ColdChains;
